import React from 'react'

const Gallery = () => {
  return (
    <div>
      <h1>gal</h1>
    </div>
  )
}

export default Gallery
